import { Component, OnInit } from '@angular/core';
import { getFrontEndApi } from '@app/core/services/utils/util.service';
import { SettingsService } from '@app/services/settings/settings.service';

@Component({
  selector: 'app-notifications-settings-page',
  templateUrl: './notifications-page.component.html',
  styleUrls: ['./notifications-page.component.scss', '../settings.scss'],
  standalone: false,
})
export class NotificationsPageComponent implements OnInit {
  tabsData;
  constructor(private settingsService: SettingsService) {}
  ngOnInit(): void {
    this.tabsData = [
      {
        label: 'Internal',
        value: 'internal',
        active: true,
      },
      {
        label: 'Slack',
        value: 'slack',
        active: false,
      },
    ];
  }

  switchTab(e) {
    this.tabsData.forEach((t) => (t.active = false));
    const selected = this.tabsData.find((t) => t.value === e);
    selected.active = true;
  }

  isActiveTab(name) {
    return this.tabsData.find((tab) => tab.value == name)?.active;
  }

  playSound() {
    this.settingsService.playSound(`${getFrontEndApi()}assets/audio/newNotification.mp3`);
  }
}
